import React from "react";
import { Tabs } from "antd";
import { ApplyDocumentView } from "./ApplyDocumentView";
import { ApplyDocumentViewItem } from "./ApplyDocumentDrawer";
const { TabPane } = Tabs;

interface Props {
  documents?: ApplyDocumentViewItem[];
  isScoringPage?: boolean;
}

export const ApplyDocumentTabs = ({ documents, isScoringPage }: Props) => {
  const [panes, setPanes] = React.useState<any[]>([]);
  // const [drawerVisible, setDrawerVisible] = React.useState(visible);
  React.useEffect(() => {
    const doCreateDocumentPanes = async () => {
      const tabPanes: any[] = [];
      if (documents != null && documents.length > 0) {
        documents.forEach((element, index) => {
          tabPanes.push(
            <TabPane tab={element.documentName} key={index}>
              <ApplyDocumentView
                viewDocument={element}
                isScoringPage={isScoringPage}
              />
            </TabPane>
          );
        });
      }
      setPanes(tabPanes);
    };
    doCreateDocumentPanes();

    // setDrawerVisible(visible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documents, isScoringPage]);

  return (
    <>
      {panes && panes.length > 0 ? (
        <Tabs defaultActiveKey="0">{panes}</Tabs>
      ) : (
        ""
      )}
    </>
  );
};
